import WDBox from "../../../../../MaterialComponents/WDBox";
import {
  Grid,
  TextField,
  Typography,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";
import * as fieldCategoryUtils from "../../../../../utils/fieldCategoryUtils";

const FIELD_TYPES = ["TEXT", "IMAGE", "PDF", "DOCUMENT"];
const ServiceField = (props) => {
  const { onRemove, item, onFieldTypeChange, onFieldTitleChange, onFieldMandatoryChange, onFieldCategoryChange } = props;
  const { title, type, mandatory, category } = item;
  const [categories, setCategories] = useState([]);
  
  // Load field categories on component mount
  useEffect(() => {
    const loadCategories = async () => {
      try {
        // Try to fetch categories from the API
        const fetchedCategories = await fieldCategoryUtils.getFieldCategories();
        if (fetchedCategories && Array.isArray(fetchedCategories) && fetchedCategories.length > 0) {
          setCategories(fetchedCategories);
        } else {
          // Create default categories from constants if API call doesn't return valid data
          const defaultCategories = Object.keys(fieldCategoryUtils.FIELD_CATEGORIES).map(key => ({
            code: key,
            displayName: fieldCategoryUtils.CATEGORY_DISPLAY_NAMES[key] || key,
          }));
          setCategories(defaultCategories);
        }
      } catch (error) {
        console.error("Error loading field categories:", error);
        // Create default categories on error
        const defaultCategories = Object.keys(fieldCategoryUtils.FIELD_CATEGORIES).map(key => ({
          code: key,
          displayName: fieldCategoryUtils.CATEGORY_DISPLAY_NAMES[key] || key,
        }));
        setCategories(defaultCategories);
      }
    };
    
    loadCategories();
  }, []);
  const actionButton = () => {
    return (
      <WDBox
        display="flex"
        flexDirection="column"
        flexGrow={1}
        alignItems="center"
        justifyContent="center"
        height="100%"
      >
        <DeleteIcon onClick={() => onRemove(item)} />
      </WDBox>
    );
  };

  const _isValid = () => {
    return title && title.trim().length != 0 && type && type.trim().length != 0;
  };

  return (
    <WDBox
      my={2}
      p={2}
      sx={{
        backgroundColor: _isValid() ? null : "#FFE0BB",
        border: 1,
        borderColor: _isValid() ? "grey.300" : "error.main",
        borderRadius: "10px",
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12} sm={3}>
          <WDBox height="100%" display="flex" alignItems="center" justifyContent="center">
            <TextField
              fullWidth
              label="Title"
              variant="outlined"
              size="small"
              value={title || ""}
              onChange={(event) => {
                onFieldTitleChange(item, event.target.value);
              }}
            />
          </WDBox>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WDBox height="100%" display="flex" alignItems="center" justifyContent="center">
            <FormControl fullWidth>
              <InputLabel id="field-type-label">Field Type</InputLabel>
              <Select
                labelId="field-type-label"
                label="Field Type"
                fullWidth
                onChange={(event) => {
                  onFieldTypeChange(item, event.target.value);
                }}
                value={type || "TEXT"}
                size="small"
                style={{ fontSize: "14px" }}
              >
                {FIELD_TYPES.map((type) => (
                  <MenuItem key={type} style={{ fontSize: "14px" }} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </WDBox>
        </Grid>
        <Grid item xs={12} sm={2}>
          <WDBox height="100%" display="flex" alignItems="center" justifyContent="center">
            <FormControl fullWidth>
              <InputLabel id="field-category-label">Category</InputLabel>
              <Select
                labelId="field-category-label"
                label="Category"
                fullWidth
                onChange={(event) => {
                  if (onFieldCategoryChange) {
                    onFieldCategoryChange(item, event.target.value);
                  }
                }}
                // Only use the category value if categories are loaded, otherwise use empty string
                value={categories.length > 0 ? (category || "SERVICE_SPECIFIC") : ""}
                size="small"
                style={{ fontSize: "14px" }}
              >
                {/* Add empty option to allow initial empty selection */}
                <MenuItem value="">Select a category</MenuItem>
                {categories.map((cat) => (
                  <MenuItem key={cat.code} style={{ fontSize: "14px" }} value={cat.code}>
                    {cat.displayName || cat.code}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </WDBox>
        </Grid>
        <Grid item xs={12} sm={2}>
          <WDBox
            display="flex"
            flexGrow={1}
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            height="100%"
          >
            <Typography variant="subtitle1" fontSize={12}>
              Is Mandatory
            </Typography>
            <Checkbox
              checked={mandatory}
              onChange={(event) => {
                onFieldMandatoryChange(item, event.target.checked);
              }}
            />
          </WDBox>
        </Grid>
        <Grid item xs={12} sm={2}>
          {actionButton()}
        </Grid>
      </Grid>
    </WDBox>
  );
};

export default ServiceField;
